import * as React from 'react';
import { InputAdornment, MaskedInput } from '@cian/ui-kit';
export var PhoneInput = function PhoneInput(_ref) {
  var disabled = _ref.disabled,
    invalid = _ref.invalid,
    inputRef = _ref.inputRef,
    mask = _ref.mask,
    onChange = _ref.onChange,
    size = _ref.size,
    value = _ref.value;
  var handleChange = React.useCallback(function (_value, _ref2) {
    var maskedValue = _ref2.maskedValue;
    onChange(maskedValue);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(MaskedInput, {
    inputRef: inputRef,
    lazy: true,
    leftAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "+7"),
    mask: mask,
    name: "phone",
    onChange: handleChange,
    placeholderChar: " ",
    value: value,
    size: size,
    disabled: disabled,
    invalid: invalid
  });
};
PhoneInput.displayName = 'PhoneInput';